export const AUTH_ACTION = {
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  UPDATE_PASSWORD: 'UPDATE_PASSWORD',
  GET_USER: 'GET_USER',
} as const;

export const SCHOOL_ACTION = {
  GET_SCHOOLS: 'GET_SCHOOLS',
  GET_STATUSES: 'GET_STATUSES',
  GET_ADMIN_SCHOOLS: 'GET_ADMIN_SCHOOLS',
  SAVE_PUBLISH_DATES: 'SAVE_PUBLISH_DATES',
  TO_PRIVATE: 'TO_PRIVATE',
  RESET_PUBLISH: 'RESET_PUBLISH',
  CHANGE_ENABLED: 'CHANGE_ENABLED',
} as const;

export const DOCUMENT_ACTION = {
  GET_OFFICIAL_DOCUMENT: 'GET_OFFICIAL_DOCUMENT',
  SAVE_OFFICIAL_DOCUMENT: 'SAVE_OFFICIAL_DOCUMENT',
  GET_RESULT_DOCUMENT: 'GET_RESULT_DOCUMENT',
  SAVE_RESULT_DOCUMENT: 'SAVE_RESULT_DOCUMENT',
} as const;
